(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      // Close desktop header-menu dropdowns
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ─── FIX: Mobile menu close-on-scroll + scroll-lock ──────────────────────────
  (function () {
    /**
     * Finds the mobile menu <details> toggle element.
     * Dawn / most Shopify themes use a <details> inside <header-drawer>
     * whose <summary> triggers the drawer open/close.
     */
    function getMobileMenuDetails() {
      const drawer = document.querySelector('header-drawer');
      if (!drawer) return null;
      return drawer.querySelector('details');
    }

    /**
     * Returns true if the mobile menu drawer is currently open.
     */
    function isMobileMenuOpen() {
      const details = getMobileMenuDetails();
      return details ? details.hasAttribute('open') : false;
    }

    /**
     * Closes the mobile menu by:
     * 1. Removing the [open] attribute from the <details> element.
     * 2. Dispatching a synthetic click on the <summary> if the custom element
     *    relies on a toggle event (handles Dawn's MenuDrawer custom element).
     * 3. Restoring body scroll.
     */
    function closeMobileMenu() {
      const drawer = document.querySelector('header-drawer');
      if (!drawer) return;

      const details = drawer.querySelector('details');
      if (!details || !details.hasAttribute('open')) return;

      // Try the custom element's own close method first (MenuDrawer in Dawn)
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else if (typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer();
      } else {
        // Fallback: click the summary to toggle it closed
        const summary = details.querySelector('summary');
        if (summary) summary.click();
      }

      // Always ensure scroll is restored in case the above didn't do it
      restoreBodyScroll();
    }

    /**
     * Locks body scroll when the mobile menu is open.
     * Mirrors what Dawn's MenuDrawer does internally, but ensures it's applied.
     */
    function lockBodyScroll() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    /**
     * Restores body scroll.
     */
    function restoreBodyScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    /**
     * Watch for the mobile menu opening / closing via MutationObserver
     * so we can toggle the scroll lock correctly.
     */
    function watchMobileMenuState() {
      const details = getMobileMenuDetails();
      if (!details) return;

      const observer = new MutationObserver(function () {
        if (details.hasAttribute('open')) {
          lockBodyScroll();
        } else {
          restoreBodyScroll();
        }
      });

      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
    }

    /**
     * Close the mobile menu when the user scrolls more than a threshold.
     * Uses a single passive scroll listener for performance.
     */
    function setupScrollCloseForMobileMenu() {
      let scrollStartY = window.pageYOffset;
      const SCROLL_THRESHOLD = 60; // px — tune as needed
      let ticking = false;

      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              if (isMobileMenuOpen()) {
                const currentY = window.pageYOffset;
                const delta = Math.abs(currentY - scrollStartY);

                if (delta >= SCROLL_THRESHOLD) {
                  closeMobileMenu();
                  // Reset baseline so repeated scrolls don't fire repeatedly
                  scrollStartY = currentY;
                }
              } else {
                // Keep baseline in sync when menu is closed
                scrollStartY = window.pageYOffset;
              }
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );
    }

    // Boot after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        watchMobileMenuState();
        setupScrollCloseForMobileMenu();
      });
    } else {
      watchMobileMenuState();
      setupScrollCloseForMobileMenu();
    }
  })();
  // ─────────────────────────────────────────────────────────────────────────────

  } catch(e) { console.error(e); }
})();
})();
